import type { SimpleEventLegacy, DSLValueLegacy } from '@verantos-dev/types-cohorts';

import { transformSimpleEventToDsl } from './transformSimpleEventToDsl';

/**
 *  This function takes in an array of subject variables and returns an array of DSL queries for the cohort definition.
 *
 * @param simpleEvents - The subject variables to transform to DSL queries
 * @returns {DSLValue[]} - The cohort definition DSL queries
 */
export const transformSimpleEventsToDsl = (simpleEvents: SimpleEventLegacy[]): DSLValueLegacy[] => {
  return simpleEvents?.map((simpleEvent) => transformSimpleEventToDsl(simpleEvent));
};
